import { TButtonsTable } from "../../Portfolios/File/types/CarteraRatioTypes";

export type TTabType = 'Backtesting' | 'DiversificacionSimulacion';

export const BACKTESTING_DESCRIPTION = 'Versión preliminar del IronIA Optimizer. En breve tendréis la explicación del funcionamiento general de esta funcionalidad.'
const DIVERSIFICATION_DESCRIPTION = 'Versión preliminar del IronIA Optimizer. En breve tendréis la explicación del funcionamiento general de esta funcionalidad.'

export const DESCRIPTIONS: Record<TTabType, string> = {
    'Backtesting': BACKTESTING_DESCRIPTION,
    'DiversificacionSimulacion': DIVERSIFICATION_DESCRIPTION,
};

export const buttonsTableList: TButtonsTable[] = [
    { text: '1M', value: '1M', },
    { text: '3M', value: '3M', },
    { text: '6M', value: '6M', },
    { text: '9M', value: '9M', },
    { text: '1Y', value: '1Y', },
    { text: '2Y', value: '2Y', },
    { text: '3Y', value: '3Y', },
    { text: 'YTD', value: 'YTD', },
    { text: 'TODO', value: 'Inception', },
];